<template>

  <li class="rent-pre-registrations-menu dropdown">
    <modal-bootstrap
      title="Fotos e Arquivos do cadastro"
      v-if="showInfoModal"
      :show="showInfoModal"
      :auto-height="true" 
      footer="none" 
      @close="closeInfoModal"
      :show-close-button="false"
    >
      <div class="subtitle text-info font-18 bold">
        Libere o cadastro antes de prosseguir
        <i class="fa fa-fw fa-info-circle"></i>
      </div>
      <hr>
      <p>Para visualizar as fotos e arquivos é necessário liberar o cadastro.</p>
      <p @click="goPageClientsList()">Clique <a>aqui</a> para liberar.</p>
    </modal-bootstrap>

    <audio ref="newRents" :src="cdn('sound.mp3')"></audio>
    <audio ref="newRentSound" :src="cdn('beep.mp3')"></audio>
    <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
      <i class="fa fa-fw fa-camera"></i><span v-if="clients.length > 0" class="bell-badge">{{ clients.length }}</span>
    </a>
    <ul class="dropdown-menu">
      <template v-if="clients.length > 0">
        <li class="dropdown-header">Arquivos recebidos</li>
        <li role="separator" class="divider"></li>
        <li v-for="(client, i) in clients" :key="i">

          <a 
            v-if="client.isOpenedOnSite === 0" 
           @click="openInfoModal()">
           {{ client.name }}
          </a>
          
          <router-link v-else :to="{name: 'clients_details', params: {clientId: client.id}, query: {tab: 'files'}}">{{ client.name }}</router-link>
        </li>
      </template>
      <li v-else class="dropdown-header">Nenhum arquivo recebido no momento</li>
    </ul>
  </li>
</template>

<script>
  import {mapState, mapActions} from 'vuex'
  // TODO: Colocar a referencia dos documentos no storage para poder limpar da tela de outros funcionários e tbm poder atualizar a página

  export default{
    name: 'ClientsPhotosMenu',
    components: {},
    data () {
      return {
        showInfoModal: false
      }
    },
    computed: {
      ...mapState({
        user: state => state.user,
        clients: state => state.photosNotificationClients
      })
    },
    watch: {
      '$route' (to, from) {
        if (to.name === 'clients_details') {
          this.removeClient(parseInt(this.$route.params.clientId))
        }
      }
    },
    mounted () {
      this.listenEvents()
    },
    methods: {
      openInfoModal () {
        this.showInfoModal = true
      },
      closeInfoModal () {
        this.showInfoModal = false
      },
      goPageClientsList () {
        this.$router.push({name: 'clients_list', query: { opened: '0' }})
        this.showInfoModal = false
      },
      removeClient (id) {
        this.removePhotoClients(id)
      },
      listenEvents () {
        window.Channel.listen('.App\\Events\\ClientsImagesReceived', (e) => {
          this.removeClient(e.id)
          this.pushPhotoClients(e)
          try {
            // this.$refs.newRents.play()
          } catch (e) {
            console.log(e)
          }
        })
        window.Channel.listen('.App\\Events\\SendUpdateUiAfterReleasing', (e) => {
          this.updatePhotoClients(e.clientId)
        })
      },
      ...mapActions(['pushPhotoClients',
        'removePhotoClients',
        'updatePhotoClients'
      ])
    }
  }
</script>


// WEBPACK FOOTER //
// ClientsPhotosMenu.vue?65875ed8